export default __webpack_public_path__ + "static/media/AWS-Certificate-Manager.39ed79a8.svg";